import axios from "axios";
import posthog from "posthog-js";
import { BASE_POSTHOG_URL } from "../../config/constants";
import { callApi } from "../generic";
import { POSTHOG_ENDPOINTS } from "./endpoints";

const { get } = axios;

export interface PosthogFlagsResponse {
  featureFlags: Record<string, boolean>;
  featureFlagPayloads: Record<string, unknown>;
}

const cachedPosthogFlagsPromises = new Map<
  string,
  Promise<PosthogFlagsResponse>
>();

export const getPosthogFlags = async (
  app: string,
  id: string | number = 1,
): Promise<PosthogFlagsResponse> =>
  callApi(() =>
    get(`${BASE_POSTHOG_URL}${POSTHOG_ENDPOINTS.FLAGS}`, {
      params: { app, id },
    }),
  );

export const getCachedPosthogFlags = (
  app = "reef",
  id: string | number = 1,
): Promise<PosthogFlagsResponse> => {
  const cacheKey = `${app}:${id}`;
  const cachedRequest = cachedPosthogFlagsPromises.get(cacheKey);

  if (cachedRequest) {
    return cachedRequest;
  }

  const request = getPosthogFlags(app, id).catch((error) => {
    posthog.captureException(error);
    cachedPosthogFlagsPromises.delete(cacheKey);
    throw error;
  });

  cachedPosthogFlagsPromises.set(cacheKey, request);

  return request;
};

export const getCachedFeatureFlag = async (
  flag: string,
): Promise<boolean | undefined> => {
  const response = await getCachedPosthogFlags();
  return response.featureFlags?.[flag];
};

export const getCachedFeatureFlagPayload = async <PayloadType>(
  flag: string,
): Promise<PayloadType | undefined> => {
  const response = await getCachedPosthogFlags();
  return response.featureFlagPayloads?.[flag] as PayloadType | undefined;
};
